import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {Globals} from '@app/services/globals.service';

export interface User {
    id: number;
    title: string;
    description: string;
}


@Injectable({
    providedIn: 'root'
})
export class ProventumApiService {


    private apiURLFetchingData = 'https://testfinanceplus.proventum.me';
    private apiURLSavingData = 'https://testfinanceplus.proventum.me';

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        })
    };

    constructor(private httpClient: HttpClient,
                public globals: Globals
    ) {
    }

    getUsers() {
        return this.httpClient.get<any>(this.apiURLFetchingData + '/proventum/api/plugin');
    }

    getAssigned(userId) {
        return this.globals.allAppUsers[userId-1];
    }

    getAllAssigned() {
        return this.httpClient.get<any>(this.apiURLFetchingData + '/proventum/api/getAllAssigned', {});
    }

    getUser(user_id) {
        let params = new HttpParams().set('user_id', user_id);
        const headers = new HttpHeaders();
        return this.httpClient.get<any>(this.apiURLFetchingData + '/proventum/api/getUser', {
          headers,
          params: params
        });

    }

    addActivity(data) {
        return this.httpClient.get<any>(this.apiURLSavingData + '/proventum/api/addActivity', data);
    }


}
